export default {
  main: "main",
  detail: "detail",
};
